import apiClient from "./apiClient";
import { cleanObject, getIdNameIfAdmin } from "../utils/commonutils";

const Url = `/customer`;

export const getCustomers = async (
  props,
  currentPage,
  rowsPerPage,
  searchText,
) => {
  try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (
      searchText !== null &&
      searchText !== undefined &&
      searchText.trim() !== ""
    ) {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const asCustomerList = (response) => {
  if (Array.isArray(response?.data?.customers)) return response.data.customers;
  if (Array.isArray(response?.data?.items)) return response.data.items;
  if (Array.isArray(response?.customers)) return response.customers;
  if (Array.isArray(response?.data) && response.data[0]?.companyName !== undefined) {
    return response.data;
  }
  return [];
};

export const getCustomerDetail = async (payload, props) => {
  try {
    if (!payload && payload.customerId) return false;
    let response = await apiClient.get(`${Url}/${payload.customerId}`);
    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const addCustomer = async (props, thisEvt) => {
  try {
    let body = {
      name: thisEvt.state?.addName,
      mobile: thisEvt.state?.addMobile,
      email: thisEvt.state?.addEmail,
      password: thisEvt.state?.addPassword,
      companyName: thisEvt.state?.addCompanyName,
      officeAddr: thisEvt.state?.addOfficeAddr,
      GST: thisEvt.state?.addGST ?? "",
      PAN: thisEvt.state?.addPAN ?? "",
      TDS: thisEvt.state?.addTDS ?? "",
    };
    const Cleabbody = cleanObject(body);
    let response = await apiClient.post(`${Url}/`, Cleabbody);
    console.log("Add Employee : ", response);
    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const editCustomer = async (props, thisEvt) => {
  try {
    let body = {
      name: thisEvt.state?.editName,
      email: thisEvt.state?.editEmail,
      mobile: String(thisEvt.state?.editMobile),
      companyName: thisEvt.state?.editCompanyName,
      officeAddr: thisEvt.state?.editOfficeAddr,
      GST: thisEvt.state?.editGST,
      PAN: thisEvt.state?.editPAN,
      TDS: thisEvt.state?.editTDS,
      // employeeId: thisEvt.state?.editEmployeeId,
    };
    console.log("Customer Edit Body : ", body);
    const Cleabbody = cleanObject(body);
    let response = await apiClient.put(
      `${Url}/?customerId=${thisEvt.state?.editId}`,
      Cleabbody,
    );
    console.log("Edit Employee : ", response);
    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const deleteCustomer = async (Deleteid, props) => {
  try {
    let response = await apiClient.delete(`${Url}/?customerId=${Deleteid}`);
    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const toggleModal = (thisEvt) => {
  const employeeObj = getIdNameIfAdmin(thisEvt?.props?.authData);
  thisEvt.setState({
    addModel: !thisEvt.state.addModel,
    addError: [],
    addName: "",
    addEmail: "",
    addMobile: "",
    addGST: "",
    addPAN: "",
    addCompanyName: "",
    addOfficeAddr: "",
    addPassword: "",
    addEmployeeId: employeeObj,
  });
};

export const toggleEditModal = (thisEvt) => {
  thisEvt.setState({
    editModel: !thisEvt.state.editModel,
    editError: [],
    editName: "",
    editEmail: "",
    editMobile: "",
    editGST: "",
    editPAN: "",
    editCompanyName: "",
    editOfficeAddr: "",
    editEmployeeId: "",
  });
};

export const handleChange = (e, thisEvt) => {
  thisEvt.setState({
    [e.target.name]: e.target.value,
  });
};

/** Admin-only: reset to a generated temporary password (returned once). */
export const resetCustomerPassword = async (id) => {
  try {
    const response = await apiClient.post(`${Url}/reset-password?customerId=${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
